import React from "react";
import { useNavigate, Outlet, useParams } from "react-router-dom";
import useAuth from "../../contexts/UserContext.tsx";
import Navbar from "../navbar/Navbar";
import SidebarSmartClass from "../sidebarSmartClass/SidebarSmartClass.jsx";
import "./privatelayout.scss";

const SmartClassLayout = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { id } = useParams();

  React.useEffect(() => {
    if (
      parseInt(id) !== parseInt(user.view_access_list.schoolID) ||
      !user.view_access_list.smartclass
    ) {
      return <h1>Unauthorized</h1>;
    }

    if (
      parseInt(id) === parseInt(user.view_access_list.schoolID) &&
      user.view_access_list.smartclass &&
      user.view_access_list.mathlab
    ) {
      navigate(`/dashboard/school/${id}`);
    }
  }, [
    id,
    user.view_access_list.schoolID,
    user.view_access_list.smartclass,
    user.view_access_list.mathlab,
    navigate,
  ]);

  return user ? (
    <div className="mainLayout">
      <Navbar />
      <div className="subLayout">
        <SidebarSmartClass />
        <div className="content">
          <Outlet />
        </div>
      </div>
    </div>
  ) : (
    navigate("/login")
  );
};

export default SmartClassLayout;
